import { axiosintance } from "./api"

export  const getemployeeTable =async(Id)=>{
  const response =await axiosintance.get(`/employee/${Id}/projects`)   
  return response.data
  }
export  const UpdateEmployeeProcessStatus =async(Id,data)=>{
  const response =await axiosintance.post(`/employee/${Id}/project/updateStatus`,data)   
  return response.data
}
export const updateDispatchStatus = async (data) => {
  const formData = new FormData();

  for (const key in data) {
    if (key === "billDetails") {
      // Iterate through the billDetails object and append its properties
      for (const billKey in data[key]) {
        formData.append(`billDetails[${billKey}]`, data[key][billKey]);
      }
    } else {
      formData.append(key, data[key]);
    }
  }

  const response = await axiosintance.patch(`/project/updateDispatchStatus`, formData);
  return response.data;
};
